import * as React from "react";
import { Loader } from "../../../../components/layout/loader";
import { request } from "../../../../services/cpln";
import { Location } from "../../../../schema/types/location/entity";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpSelect } from "../../../gvc/testNewForm/CpSelect";

interface Props {}
export const AccountCreateOrgGvc: React.FC<Props> = ({}) => {
  // const dispatch = useAppDispatch();

  // const orgName = useCpFormValue(`orgName`);
  // const gvcName = useCpFormValue(`gvcName`);
  // const locationNames = useCpFormValue(`locationNames`);

  const [allLocations, setAllLocations] = React.useState<Location[]>([]);
  const [allLocationsFetched, setAllLocationsFetched] = React.useState<boolean>(false);
  React.useEffect(() => {
    fetchAllLocations();
  }, []);

  async function fetchAllLocations() {
    try {
      const { data } = await request({ url: "/admin/locations/enabled" });
      setAllLocations(data.items);
      setAllLocationsFetched(true);
    } catch (e) {
      setAllLocationsFetched(true);
    }
  }

  if (!allLocationsFetched) {
    return <Loader />;
  }

  return (
    <div className="account-create-org-gvc">
      <CpFormItem>
        <CpLabel name={`orgName`}>Org Name</CpLabel>
        <CpInput name={`orgName`} />
        <CpErrorWarning name={`orgName`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`gvcName`}>GVC Name</CpLabel>
        <CpInput name={`gvcName`} />
        <CpErrorWarning name={`gvcName`} />
      </CpFormItem>
      {allLocations.length > 0 ? (
        <CpFormItem>
          <CpLabel name="locationNames">Locations</CpLabel>
          <CpSelect
            name={`locationNames`}
            mode="multiple"
            options={allLocations.map((l) => ({
              label: l.name,
              value: l.name,
            }))}
          />
          <CpErrorWarning name="locationNames" />
        </CpFormItem>
      ) : null}
    </div>
  );
};
